import { apiPost } from '../client';
import type { Traveller, TravellerRequest, TravellerResponse } from '../types/traveller';

/**
 * `Traveller/*` — saved-passenger ("Kayıtlı Yolcu") list / edit / delete + type-ahead,
 * backed by the Mongo `paxlookup` collection scoped to the caller's GSA. Confirmed live
 * 2026-08-28 (routes `Traveller/GetTravellers`, `GetTravellerById`, `EditTraveller`,
 * `DeleteTraveller`, `Autocomplete`). Session goes in the `{ sessionHeader }` wrapper
 * (`apiPost`), matching the worker's `request.SessionHeader` check.
 *
 * Create: `Traveller/AddTraveller` — CONFIRMED live 2026-08-31 (`localhost:1538`); needs at
 * least `firstName` + `lastName`, response is the same `{ travellers, traveller,
 * successMessage }` envelope. (`Lookup/Save`, the legacy inline-booking save path, is 404.)
 */

/** Yeni kayıtlı yolcu ekle (`Traveller/AddTraveller`). Ad + soyad zorunlu. */
export function addTraveller(traveller: Traveller): Promise<TravellerResponse> {
  return apiPost<TravellerRequest, TravellerResponse>('Traveller/AddTraveller', { traveller });
}

/** All saved passengers for the GSA, or those matching `key` (name / T.C. kimlik). */
export function getTravellers(key?: string): Promise<TravellerResponse> {
  return apiPost<TravellerRequest, TravellerResponse>(
    'Traveller/GetTravellers',
    key && key.trim() ? { key: key.trim() } : {}
  );
}

export function getTravellerById(id: string): Promise<TravellerResponse> {
  return apiPost<TravellerRequest, TravellerResponse>('Traveller/GetTravellerById', { id });
}

/** Type-ahead by name or T.C. kimlik / passport — `key` is matched server-side
 *  (diacritic-folded, upper-cased) against firstName / lastName / fullName / identity. */
export function autocompleteTravellers(key: string, take = 10): Promise<TravellerResponse> {
  return apiPost<TravellerRequest, TravellerResponse>('Traveller/Autocomplete', { key, take });
}

/** Update an existing saved passenger (`traveller.id` required). */
export function editTraveller(traveller: Traveller): Promise<TravellerResponse> {
  return apiPost<TravellerRequest, TravellerResponse>('Traveller/EditTraveller', { traveller });
}

export function deleteTraveller(id: string): Promise<TravellerResponse> {
  return apiPost<TravellerRequest, TravellerResponse>('Traveller/DeleteTraveller', { id });
}
